import React from 'react';
import ArticleTransactionsButtonProperties from "./ArticleTransactionsButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import ArticleTransactionsStore from "./ArticleTransactionsStore";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ArticleTransactionsButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import ShowTransactionLegend from '../../Info/ShowTransactionLegend/ShowTransactionLegend';
import ArticleTransactions from '../../Info/ArticleTransactions/ArticleTransactions';
import Box from '../../../ui_components/Box/Box';
import Width from '../../../ui_components/common/enums/Width';
import Alignment from '../../../ui_components/common/enums/Alignment';
import ShowSellerBasicInfo from '../../Info/ShowSellerBasicInfo/ShowSellerBasicInfo';


const ArticleTransactionsButton: React.FC<ArticleTransactionsButtonProperties> = ({
                                                                                onClick = () => {
                                                                                },
                                                                                onSave = () => {
                                                                                },
                                                                                showIcon = true,
                                                                                showText = true,
                                                                                disabled,
                                                                                className = '',
                                                                                articleId,
                                                                                rounded = false,
                                                                                size = ButtonSize.DEFAULT,
                                                                                type = ButtonType.DEFAULT
                                                                            }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new ArticleTransactionsStore(commonContext, articleId);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const text = i18n.translate("TRANSACTIONS")
    const Icon = AccountBalanceIcon;
    if (!userStore.hasAccess(Access.GET_TRANSACTIONS.valueOf())) {
        return <></>;
    }
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    
    return <Observer>
        {() => (
            <>
                <SidePanel title={text} onClose={onCloseModal} open={store.isModalOpen}
                           className={classes.modal_container}>
                    <Box
                        width={Width.FULL_WIDTH}
                        justifyContent={Alignment.SPACE_BETWEEN}>
                        <ShowSellerBasicInfo autofill name={store.article.name}/>
                    </Box>
                    <ShowTransactionLegend className={classes.legend_container}/>
                    <ArticleTransactions articleId={articleId}/>
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default ArticleTransactionsButton;
